// extracted by mini-css-extract-plugin
export var container = "_6l-0";
export var icon = "_6l-1";
export var text = "_6l-2";